import { Code2, PaintBucket, Wrench } from 'lucide-react';

export interface Service {
  id: number;
  title: string;
  description: string;
  icon: typeof Code2 | typeof PaintBucket | typeof Wrench;
  features: string[];
  detailedDescription: string;
}

export const services: Service[] = [
  {
    id: 1,
    title: 'Full-Stack Development',
    description: 'End-to-end web applications with seamless front-end and back-end integration.',
    icon: Code2,
    features: [
      'Custom web application development',
      'Front-end and back-end expertise',
      'Database design and implementation',
      'API development and integration',
      'Authentication and security implementation',
      'Performance optimization',
      'Scalable architecture'
    ],
    detailedDescription: `
      Our full-stack development service provides comprehensive solutions for businesses needing robust, scalable web applications. With British expertise and a global presence, we deliver end-to-end development that seamlessly integrates front-end and back-end technologies.
      
      We specialize in creating custom web applications that solve specific business challenges. From complex e-commerce platforms to custom CRM systems, our team delivers solutions that drive efficiency and growth.
      
      Our development approach focuses on scalability, security, and performance. We build applications that can grow with your business, protect your data, and provide excellent user experiences.
      
      Technologies we work with include React, Angular, Node.js, Python, PHP, MySQL, PostgreSQL, MongoDB, and more. We select the right technology stack based on your specific requirements rather than forcing a one-size-fits-all approach.
    `
  },
  {
    id: 2,
    title: 'Web Design',
    description: 'Beautiful, modern, and responsive designs that enhance your brand and engage users.',
    icon: PaintBucket,
    features: [
      'Responsive and mobile-first design',
      'User experience (UX) optimization',
      'Brand-aligned visual design',
      'Interactive prototypes',
      'Accessibility compliance',
      'SEO-friendly structure',
      'Cross-browser compatibility'
    ],
    detailedDescription: `
      Our web design service focuses on creating beautiful, functional websites that reflect your brand and meet your business objectives. We combine aesthetics with strategy to deliver designs that not only look great but also convert visitors into customers.
      
      Every design begins with understanding your business, audience, and goals. We conduct thorough research to ensure our designs align with user expectations and industry standards while maintaining your unique brand identity.
      
      We create fully responsive designs that work flawlessly across all devices. Our mobile-first approach ensures excellent user experiences on smartphones, tablets, and desktops alike.
      
      Accessibility is built into our design process. We ensure that your website is usable by people with various disabilities, complying with WCAG standards and making your content available to the widest possible audience.
      
      Our designs are optimized for search engines from the ground up, with clean code, fast loading times, and structured data that helps your site rank higher in search results.
    `
  },
  {
    id: 3,
    title: 'Monthly Maintenance',
    description: 'Comprehensive website care to ensure security, performance, and ongoing optimization.',
    icon: Wrench,
    features: [
      'Regular security updates and monitoring',
      'Performance optimization',
      'Content updates and management',
      'Backup and disaster recovery',
      'Technical support and troubleshooting',
      'Analytics monitoring and reporting',
      'SEO maintenance and improvements'
    ],
    detailedDescription: `
      Our monthly maintenance service provides peace of mind by ensuring your website remains secure, fast, and effective. We handle all the technical aspects of website care so you can focus on your business.
      
      Security is our top priority. We perform regular updates, security scans, and monitoring to protect your website from threats. Our comprehensive backup system ensures your data is safe and can be quickly restored if needed.
      
      We continuously optimize your website's performance to ensure fast loading times and smooth operation. Regular checks and adjustments keep everything running at peak efficiency.
      
      Our team can handle content updates, ensuring your website stays fresh and relevant. Whether you need regular blog posts, product updates, or occasional content changes, we've got you covered.
      
      We monitor your website's analytics to identify opportunities for improvement and provide regular reports on performance, traffic, and user behavior. These insights help guide ongoing optimization efforts.
      
      Technical support is always available when you need it. Our team can quickly address any issues that arise, minimizing downtime and maintaining a positive user experience.
    `
  }
];